"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextEditor = void 0;
const classnames_1 = __importDefault(require("classnames"));
const draft_js_1 = require("draft-js");
const draft_js_import_html_1 = require("draft-js-import-html");
require("draft-js/dist/Draft.css");
const react_1 = require("react");
const React = __importStar(require("react"));
const index_1 = require("../../index");
const textEditorUtils_1 = require("./textEditorUtils");
const TextEditor = (props) => {
    const { initialEditorText, label, disabled, onChange, } = props;
    const setInitialEditorState = () => {
        return initialEditorText
            ? draft_js_1.EditorState.createWithContent(draft_js_import_html_1.stateFromHTML(initialEditorText))
            : draft_js_1.EditorState.createEmpty();
    };
    const [editorState, setEditorState] = react_1.useState(setInitialEditorState);
    react_1.useEffect(() => {
        if (onChange) {
            onChange({ editorState, html: textEditorUtils_1.convertToHTML(editorState) });
        }
    }, [editorState]);
    const inlineStylingOptions = [
        {
            label: 'B',
            styling: 'BOLD',
        },
        {
            label: 'I',
            styling: 'ITALIC',
        },
        {
            label: 'U',
            styling: 'UNDERLINE',
        },
    ];
    const setInlineStyling = (event, style) => {
        event.preventDefault();
        const nextState = draft_js_1.RichUtils.toggleInlineStyle(editorState, style);
        setEditorState(nextState);
    };
    return (React.createElement("div", { className: classnames_1.default({
            'text-editor-container': true,
            'text-editor-container-disabled': disabled,
        }) },
        label && React.createElement(index_1.Label, null, label),
        React.createElement("div", { className: "form-control" },
            React.createElement(draft_js_1.Editor, { editorState: editorState, onChange: setEditorState, stripPastedStyles: true, readOnly: disabled })),
        React.createElement("div", { className: "styling-controls" }, inlineStylingOptions.map((stylingButton) => {
            const buttonSelectedStyling = editorState
                .getCurrentInlineStyle()
                .has(stylingButton.styling)
                ? 'styleSelected'
                : '';
            return (React.createElement("div", { key: stylingButton.styling, className: `styling-button ${stylingButton.styling}-button ${buttonSelectedStyling}`, onMouseDown: (event) => {
                    if (!disabled) {
                        setInlineStyling(event, stylingButton.styling);
                    }
                } }, stylingButton.label));
        }))));
};
exports.TextEditor = TextEditor;
//# sourceMappingURL=TextEditor.js.map